import { TweenMax, Power3 } from 'gsap';

class Store {
  constructor() {
    this.dom = {
      button: document.querySelector('.js-expand-toggle'),
      content: document.querySelector('.js-expand-content'),
      navItems: document.querySelectorAll('.js-nav-button'),
      label: document.querySelector('.js-nav-label'),
      collage: document.querySelector('.js-collage'),
      store: document.querySelector('.js-store'),
    };

    this.state = {
      labelVisible: false,
      contentExpanded: false
    };
  }

  toggleContent = () => {
    this.dom.content.classList.toggle('toggle--is-open');
    this.dom.button.classList.toggle('button--expand-active');

    // Set variables for toggle of text
    let openText = this.dom.button.getAttribute('data-open-text');
    let closedText = this.dom.button.getAttribute('data-closed-text');

    // set button text
    if (this.state.contentExpanded) this.dom.button.innerHTML = `<span></span>${closedText}`;
    if (!this.state.contentExpanded) this.dom.button.innerHTML = `<span></span>${openText}`;

    // toggle state
    this.state.contentExpanded = !this.state.contentExpanded;
  }

  toggleLabel = (el) => {
    if (!el) return;

    // toggle class to show/hide label
    this.dom.label.classList.toggle('store__nav--label-visible');

    // set content in label
    if (!this.state.labelVisible) this.dom.label.innerHTML = el.getAttribute('data-hover-label');
    if (this.state.labelVisible) this.dom.label.innerHTML = '';

    // toggle state
    this.state.labelVisible = !this.state.labelVisible;
  }

  animateCollage = (y) => {
    TweenMax.to(
      this.dom.collage,
      0.4,
      { y: -y, ease: Power3.easeOut }
    );
  }

  scrollHandler = () => {
    if (!this.dom.store || !this.dom.collage) return;

    let offsetY = window.pageYOffset;
    let maxOffsetY = document.body.scrollHeight - window.innerHeight;
    let differenceY = this.dom.collage.offsetHeight - this.dom.store.offsetHeight;
    let ratio = offsetY / maxOffsetY;
    let pushValue = ratio * differenceY;

    if (pushValue > 0) requestAnimationFrame(() => this.animateCollage(pushValue));
  }

  init = () => {
    if (this.dom.button) {
      this.dom.button.addEventListener('click', this.toggleContent, { passive: true });
    }

    [...this.dom.navItems].forEach((navItem) => {
      navItem.addEventListener('mouseenter', () => this.toggleLabel(navItem), { passive: true });
      navItem.addEventListener('mouseleave', () => this.toggleLabel(navItem), { passive: true });
    });

    window.addEventListener('scroll', this.scrollHandler);
  }

  destroy = () => {
    if (this.dom.button !== null) {
      this.dom.button.removeEventListener('click', this.toggleContent);
    }

    [...this.dom.navItems].forEach((navItem) => {
      navItem.removeEventListener('mouseenter', () => this.showLabel(navItem));
      navItem.removeEventListener('mouseleave', () => this.clearLabel(navItem));
    });

    window.removeEventListener('scroll', this.scrollHandler);
  }
}

export default Store;
